import {
  InternalChromeConfig,
  getChromeContext as btswGetChromeContext,
} from '@amzn/aac-chrome-internal-api';
import { isBtswContext, isFromTrim, isFromBtswWc } from 'src/commons/utils';
import getChromeData from './get-chrome-data';

export default async (): Promise<InternalChromeConfig> => {
  // window.AACChrome is injected by Trim's headerView.jsp, independently of the
  // mons meta tag isFromTrim checks.
  if (isFromTrim() && window.AACChrome?.InternalAPI) {
    // Trim initializes the internal configuration using by setting it in the InternalChromeConfigHandler
    //code.amazon.com/packages/AdvertisingConsoleTrimService/blobs/fe07fbf147a3f15f6d3b82b6369ee828a6f8720d/--/src/main/resources/META-INF/resources/views/headerView.jsp#L36
    return window.AACChrome.InternalAPI.InternalChromeConfigHandler.getInstance()
      .internalChromeConfig as InternalChromeConfig;
  } else if (isBtswContext() || isFromBtswWc()) {
    // ChromeContext carries the same runtime payload as InternalChromeConfig but
    // types nearly every field as optional, so it is not structurally
    // assignable. Narrow once here rather than fabricating defaults for a dozen
    // fields that every caller already treats as present.
    return btswGetChromeContext() as InternalChromeConfig;
  }

  const chromeData = await getChromeData();
  return chromeData.internalChromeConfig;
};
